
import React, {FC} from 'react';
import classNames from 'classnames';
import {TimeSlot} from 'components/TimePicker/types';

import * as styles from './styles.module.scss';

interface SlotProps {
	slot: TimeSlot
	selected?: boolean
	disabled?: boolean
	onSelect: (v?: TimeSlot) => void
}

const Slot: FC<SlotProps> = ({slot, selected, disabled, onSelect}) => {
	const props = {
		className: classNames({
			[styles.slot]: true,
			[styles.selected]: selected,
		}),

		disabled,

		onClick: () => {
			if (selected) {
				onSelect(undefined);
			} else {
				onSelect(slot);
			}
		}
	};

	return (
		<button {...props}>
			{slot.time12h}
		</button>
	);
};

export default Slot;
